module.exports = __webpack_public_path__ + "assets/c71c86a38cf1b37d846f930c859ba60a.mp4";